import type {
    CSSProperties
} from "react";
import type {
    AnatomySampleMap
} from "../types";
import {
    Command,
    Dialog,
    Button,
    Toast,
    Sheet,
    Text
} from "ncore-ui-kit";
import {
    CheckIcon,
    InfoIcon,
    UserIcon,
    BellIcon,
    HomeIcon
} from "../icons";
import {
    shapeConfigs
} from "../sampleTokens";

const SHEET_FRAME_STYLE: CSSProperties = {
    height: shapeConfigs.chartHeight.large,
    width: shapeConfigs.contentMaxWidth,
    position: "relative"
};

export const layerSamples: AnatomySampleMap = {
    Sheet: (t) => ({
        node: <div
            style={SHEET_FRAME_STYLE}
        >
            <Sheet
                isModal={false}
                isOpen={true}
            >
                <Sheet.Content>
                    <Sheet.Header
                        description={t("sample.description")}
                        title={t("sample.title")}
                    />
                    <Sheet.Body>
                        <Text>
                            {t("sample.body")}
                        </Text>
                    </Sheet.Body>
                    <Sheet.Footer>
                        <Button
                            title={t("sample.cancel")}
                            onPress={() => undefined}
                            variant="outline"
                            type="neutral"
                        />
                        <Button
                            title={t("sample.action")}
                            onPress={() => undefined}
                        />
                    </Sheet.Footer>
                </Sheet.Content>
            </Sheet>
        </div>,
        width: shapeConfigs.contentMaxWidth,
        maxScale: 2
    }),
    Command: (t) => ({
        node: <Command
            variant="inline"
        >
            <Command.Input
                placeholder={t("sample.search")}
            />
            <Command.List>
                <Command.Group
                    title={t("sample.label")}
                >
                    <Command.Item
                        title={t("sample.item1")}
                        icon={UserIcon}
                    />
                    <Command.Item
                        title={t("sample.item2")}
                        icon={BellIcon}
                    />
                </Command.Group>
                <Command.Separator />
                <Command.Group
                    title={t("sample.title")}
                >
                    <Command.Item
                        title={t("sample.item3")}
                        icon={HomeIcon}
                    />
                </Command.Group>
            </Command.List>
            <Command.Footer />
        </Command>,
        width: shapeConfigs.dialogMaxWidth,
        maxScale: 2
    }),
    SnackBar: (t) => ({
        node: <Toast
            subTitle={t("sample.description")}
            action={{
                onPress: () => undefined,
                title: t("sample.action")
            }}
            title={t("sample.title")}
            isWorkWithPortal={false}
            isShowAction={true}
            isAutoClose={false}
            isCompact={false}
            icon={CheckIcon}
            id="anatomy"
        />,
        maxScale: 3
    }),
    Toast: (t) => ({
        node: <Toast
            subTitle={t("sample.description")}
            action={{
                onPress: () => undefined,
                title: t("sample.action")
            }}
            title={t("sample.title")}
            isWorkWithPortal={false}
            isShowAction={true}
            isAutoClose={false}
            isShowClose={true}
            icon={CheckIcon}
            id="anatomy"
        />,
        maxScale: 3
    }),
    Dialog: (t) => ({
        node: <Dialog
            content={t("sample.description")}
            secondaryButtonProps={{
                title: t("sample.cancel")
            }}
            primaryButtonProps={{
                title: t("sample.action")
            }}
            title={t("sample.title")}
            withModal={false}
            variant="yes-no"
            icon={InfoIcon}
            isOpen={true}
        />,
        width: shapeConfigs.dialogMaxWidth,
        maxScale: 2
    })
};
